module.exports = __webpack_public_path__ + "static/media/3_r_Layer3_78.88_0.c8651452.png";